import React from 'react';
import useLangTranslation from '../../customHooks/languageProvider';
import { Link } from 'react-router-dom';

const AuthSignUp = () => {
    const { getLangTranslation } = useLangTranslation();
    return (
        <p className="text-center my-6 fw-semibold">
            {getLangTranslation("LOGIN_CHILD_DON'T_HAVE_AN_ACC", "Don't have an account?")}<Link to='/auth/create-an-account' className="ms-1">{getLangTranslation('LOGIN_CHILD_SIGN_UP', 'Sign Up')}</Link>
        </p>
    )
}

export default AuthSignUp